import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { REPORTING_TABS } from '../constants';
import type { IReportingTabsNavProps, ReportingTabId } from '../interfaces';

/** Routed MUI tab navigation with brand pill styling. */
export const ReportingTabsNav = ({ activeTab, onChange }: IReportingTabsNavProps) => {
  return (
    <Box
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        px: { xs: 2, sm: 3 },
        py: 1.5,
      }}
    >
      <Tabs
        value={activeTab}
        onChange={(_, newTab: ReportingTabId) => onChange(newTab)}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="Reporting tabs"
      >
        {REPORTING_TABS.map((tab) => {
          const Icon = tab.icon;
          return (
            <Tab
              key={tab.id}
              value={tab.id}
              label={tab.label}
              icon={<Icon size={16} />}
              iconPosition="start"
              id={`reporting-tab-${tab.id}`}
              aria-controls={`reporting-tabpanel-${tab.id}`}
            />
          );
        })}
      </Tabs>
    </Box>
  );
};
